import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import Head from "next/head";
import { useContext } from "react";
import CMP from "Components/CMP";

const Meta = () => {
  const { config } = useContext<publicationTypes>(PublicationContext);

  return (
    <>
      <CMP />
      <Head>
        
        {/* Google Tag Manager */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${config.gtm_id}');
      `,
          }}
        />
        {/* End Google Tag Manager */}
      </Head>
    </>
  );
};
export default Meta;
